/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletIcon16Solid = forwardRef('TextBulletIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3 5.25A1.251 1.251 0 1 0 3 2.75a1.251 1.251 0 0 0 0 2.502Z" }),
        React.createElement("path", { d: "M6 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M7 7a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H7Z" }),
        React.createElement("path", { d: "M7 11a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H7Z" }),
        React.createElement("path", { d: "M3 13.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" }),
        React.createElement("path", { d: "M4.25 8A1.251 1.251 0 1 1 1.75 8a1.251 1.251 0 0 1 2.502 0Z" })));
});
